/**
 * Search configuration constants
 * These values are used across the search implementation and tests
 * to ensure consistency between production code and test expectations
 */

// Minimum score thresholds for different search contexts
export const MIN_SCORES = {
  // Regular artist search - aligned with instant search for consistency
  ARTIST_SEARCH: 0.4,

  // Instant search (autocomplete) - lenient for quick suggestions
  ARTIST_INSTANT_SEARCH: 0.4,

  // Select box searches - very lenient to show all options
  SELECT_BOX: 0.1,
} as const

// Export individual constants for backwards compatibility
export const ARTIST_SEARCH_MIN_SCORE = MIN_SCORES.ARTIST_SEARCH
export const ARTIST_INSTANT_SEARCH_MIN_SCORE = MIN_SCORES.ARTIST_INSTANT_SEARCH
export const SELECT_BOX_MIN_SCORE = MIN_SCORES.SELECT_BOX
